export const education = [
	{
		id:1,
		edu: '10th || Maharashtra State Board(SSC)',
		year : '2020',
		name: 'K.R.T. HighSchool',
		status: 'Passed with - 93.80%',
	},
	{
		id:2,
		edu: 'Diploma || Computer Technology',
		year : '2023',
		name: 'Government Polytechnic, Nashik',
		status: 'Passed with - 92%',
	},
	{
		id:3,
		edu: "Bacholer's Of Engineering || Computer Engineering",
		year : '2023-2026',
		name: ' Karmaveer Baburao Thakare College Of Engineering, Nashik',
		status: 'Currently Pursuing - 9.27',
	},


]

export const experience = [
	{
		id:1,
		designation : 'Web Developer Intern',
		company : 'Codevertex',
		period : 'July,2023 - October,2023',
		description : [ 
		'As a intern, gained frontend and backend experience, contributed to site development and maintenance.',
		'Contributed to the design and development of administrative systems, CRM solutions, and client-specific projects under the guidance of experienced professionals.',
	]
	},
	{
		id:2,
		designation : 'Data Analyst Intern',
		company : ' Robert Bosch',
		period : 'December,2024 - February,2025',
		description : [ 
		'I have develope in a Python project that involves capturing screenshots of different applications and using a comparison mechanism to detect variations or disparities between them.',

	]
	}
]
